module.exports = __webpack_public_path__ + "img/empty.e3475796.png";